/* ================================================================
   SaniZone analytics plumbing
   ----------------------------------------------------------------
   GTM-T8FLBCZ5 + Consent Mode v2 worden inline in theme.liquid
   geladen vóór alle andere scripts. Dit bestand bevat alleen de
   `window.Analytics` helper voor GA4-formatted dataLayer-pushes.

   Pattern: alle e-commerce events worden gepushed als
     { event: '<name>', ecommerce: { currency, value, items[], ... } }
   met een voorafgaande `ecommerce: null` reset zodat GTM elke push
   als losse event ziet (canonical GA4 pattern, vereist door GTM).
   ================================================================ */

(function () {
  'use strict';

  window.dataLayer = window.dataLayer || [];

  function pushEcom(event, payload) {
    window.dataLayer.push({ ecommerce: null });
    window.dataLayer.push({ event: event, ecommerce: payload || {} });
  }

  function totalValue(cart) {
    return (cart || []).reduce(function (s, i) { return s + (i.price || 0) * (i.qty || 1); }, 0);
  }

  function mapCart(cart) {
    return (cart || []).map(function (i) {
      return {
        item_id: i.handle, item_name: i.title, price: i.price,
        quantity: i.qty || 1, item_brand: i.brand, item_category: i.collection
      };
    });
  }

  const Analytics = window.Analytics = {
    push(event, payload) {
      window.dataLayer.push(Object.assign({ event: event }, payload || {}));
    },
    viewItem(p) {
      pushEcom('view_item', {
        currency: 'EUR',
        value: p.price,
        items: [{
          item_id: p.handle, item_name: p.title, price: p.price,
          item_brand: p.brand, item_category: p.collection, quantity: 1
        }]
      });
    },
    viewItemList(slug, items) {
      pushEcom('view_item_list', {
        item_list_id: slug,
        item_list_name: slug,
        items: (items || []).slice(0, 24).map(function (p, idx) {
          return {
            item_id: p.handle, item_name: p.title, price: p.price,
            item_brand: p.brand, item_category: p.collection, index: idx + 1
          };
        })
      });
    },
    selectItem(slug, p, idx) {
      pushEcom('select_item', {
        item_list_id: slug,
        item_list_name: slug,
        items: [{
          item_id: p.handle, item_name: p.title, price: p.price,
          item_brand: p.brand, item_category: p.collection, index: idx || 1
        }]
      });
    },
    addToCart(p, qty) {
      pushEcom('add_to_cart', {
        currency: 'EUR',
        value: (p.price || 0) * (qty || 1),
        items: [{
          item_id: p.handle, item_name: p.title, price: p.price, quantity: qty || 1,
          item_brand: p.brand, item_category: p.collection
        }]
      });
    },
    removeFromCart(p, qty) {
      pushEcom('remove_from_cart', {
        currency: 'EUR',
        value: (p.price || 0) * (qty || 1),
        items: [{
          item_id: p.handle, item_name: p.title, price: p.price, quantity: qty || 1
        }]
      });
    },
    viewCart(cart) {
      pushEcom('view_cart', {
        currency: 'EUR',
        value: totalValue(cart),
        items: mapCart(cart)
      });
    },
    beginCheckout(cart) {
      pushEcom('begin_checkout', {
        currency: 'EUR',
        value: totalValue(cart),
        items: mapCart(cart)
      });
    },
    purchase(orderId, cart, shipping, tax) {
      pushEcom('purchase', {
        transaction_id: orderId,
        currency: 'EUR',
        value: totalValue(cart),
        shipping: shipping || 0,
        tax: tax || 0,
        items: mapCart(cart)
      });
    },
    search(term) { this.push('search', { search_term: term }); },
    signUp(method) { this.push('sign_up', { method: method || 'newsletter' }); },
    scanCompleted(score, style)        { this.push('scan_completed', { score: score, style: style }); },
    moodboardGenerated(style, m2, cost){ this.push('moodboard_generated', { style: style, m2: m2, cost: cost }); },
    redesignGenerated(products)        { this.push('redesign_generated', { product_count: (products || []).length }); },
    b2bRequest(items)                  { this.push('b2b_account_request', { items: items }); }
  };

  // UTM-preservation (cross-page) — opslaan in sessionStorage zodat checkout-URL ze niet kwijtraakt
  try {
    const params = new URLSearchParams(location.search);
    const utm = {};
    ['utm_source','utm_medium','utm_campaign','utm_content','utm_term','gclid','fbclid']
      .forEach(function (k) { const v = params.get(k); if (v) utm[k] = v; });
    if (Object.keys(utm).length) {
      sessionStorage.setItem('sh_utm', JSON.stringify(Object.assign(
        JSON.parse(sessionStorage.getItem('sh_utm') || '{}'),
        utm
      )));
    }
    const stored = JSON.parse(sessionStorage.getItem('sh_utm') || '{}');
    if (Object.keys(stored).length) {
      window.__sh_utm = stored;
      Analytics.push('utm_captured', stored);
    }
  } catch (e) { /* ignore */ }

})();
